import {Injectable} from "@angular/core";
import {Http, ResponseContentType} from "@angular/http";
import {CookieService} from "ngx-cookie";
import {Headers} from "@angular/http";

import "rxjs/add/operator/map";

@Injectable()
export class CatalogService {
  constructor(private http: Http, private _cookieService: CookieService) {}

  getCatalog(catalogId, token) {
    return this.http
      .post(
        `https://api.microstore-oracle.nendi.fr/microstore/catalog/${catalogId}`,
        {token}
      )
      .map((res) => {
        return res.json().body;
      });
  }

  sendOracleCart(hook, data) {
    // const contentHeaders = new Headers();
    // contentHeaders.append("Content-Type", "application/json");

    const headers = new Headers();
    headers.append("Access-Control-Allow-Origin", "*");
    // headers.append("Content-Type", "text/xml");
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    headers.append(
      "Access-Control-Allow-Headers",
      "X-Requested-With, Content-Type, Origin, Authorization, Accept, Client-Security-Token, Accept-Encoding"
    );
    headers.append(
      "Access-Control-Allow-Methods",
      "POST, GET, OPTIONS, DELETE, PUT"
    );
    let toto = hook.replace(/&amp;/g, "&");
    console.log("----> hook", toto);
    console.log("----> data", data);
    // let stringData = JSON.stringify(data);
    let encodedData = encodeURI(data);
    let tititi = encodeURIComponent(data);
    console.log("---> encodedData", encodedData);
    console.log("---> tititi", tititi);

    return this.http.post(
      // `http://localhost:3095/shopping-cart/sendOracleCart`,
      `${toto}?cXML-urlencoded=${encodedData}`,
      // {
      //   "cxml-urlencoded": encodedData,
      // },
      {headers: headers}
    );
  }
}

// http://localhost:4200/oracle/catalog/5902fb7704c176790a7124b2?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImNhcGdlbWluaSIsImlzT3JhY2xlIjp0cnVlLCJob29rX3VybCI6Imh0dHBzOi8vZmllYnNiYXMuY29ycC5jYXBnZW1pbmkuY29tOjQ0NDcvT0FfSFRNTC9PQS5qc3A_T0FGdW5jPUlDWF9DQVRfUFVOQ0hPVVRfQ0FMTEJBQ0smT0FIUD1JQ1hfUE9SX0hPTUVQQUdFX01FTlUmT0FTRj1JQ1hfQ0FUX1BVTkNIT1VUX0NBTExCQUNLJnRyYW5zYWN0aW9uaWQ9MjcwOTM5NTU0Jm9wZXJhdGlvbmtleT05NGJlNmEyNjMzZDJiNWJlIiwiaWF0IjoxNjEwNTM1NzMyfQ.skDrL2fK0Z3Z7Ylw_uq4i9aVkoI3k-H4UrERq2sn7M0&HOOK_URL=https://fiebsbas.corp.capgemini.com:4447/OA_HTML/OA.jsp?OAFunc=ICX_CAT_PUNCHOUT_CALLBACK&amp;OAHP=ICX_POR_HOMEPAGE_MENU&amp;OASF=ICX_CAT_PUNCHOUT_CALLBACK&amp;transactionid=270939554&amp;operationkey=94be6a2633d2b5be



// WEBPACK FOOTER //
// ./src/app/services/catalog.service.ts